/**
 * Stable, deterministic string for cache / request keys (object keys sorted lexicographically).
 * Prefer this over `JSON.stringify` alone when object key order must not affect the output.
 */
export default function stableStringifyForCacheKey(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map(stableStringifyForCacheKey).join(',')}]`
  }
  if (value && typeof value === 'object') {
    return `{${Object.entries(value as Record<string, unknown>)
      .sort(([left], [right]) => left.localeCompare(right))
      .map(([key, entryValue]) => `${JSON.stringify(key)}:${stableStringifyForCacheKey(entryValue)}`)
      .join(',')}}`
  }
  return JSON.stringify(value) ?? 'undefined'
}
